"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncContent = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var constant_1 = require("../../constant");
var layout_1 = require("../layout");
var Loading_1 = __importDefault(require("../Loading/Loading"));
var ResultBoundary_1 = __importDefault(require("../ResultBoundary"));
var constants_1 = require("./constants");
var context_1 = require("./context");
var createContentStyle = function (theme, size) {
    return react_1.css(__assign({ position: 'relative' }, (theme.name === constant_1.DESIGN_SYSTEM ? ({
        padding: constants_1.SIZE_TO_PADDING[size],
    }) : {
        padding: '15px 30px',
    })));
};
var CardContent = function (props) {
    var theme = react_1.useTheme();
    var size = react_2.useContext(context_1.CardContext).size;
    var contentStyle = react_2.useMemo(function () { return createContentStyle(theme, size); }, [theme, size]);
    return react_1.jsx("div", __assign({}, props, { css: contentStyle }));
};
var DEFAULT_LOADING = function () { return (react_1.jsx(layout_1.Flex, { alignItems: "center", justifyContent: "center", css: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        minHeight: 64,
    } },
    react_1.jsx(Loading_1.default.Spinner, null))); };
function AsyncContent(_a) {
    var result = _a.result, children = _a.children, _b = _a.renderLoading, renderLoading = _b === void 0 ? DEFAULT_LOADING : _b, renderError = _a.renderError, props = __rest(_a, ["result", "children", "renderLoading", "renderError"]);
    return (react_1.jsx(CardContent, __assign({}, props),
        react_1.jsx(ResultBoundary_1.default, { result: result, renderLoading: renderLoading, renderError: renderError }, children)));
}
exports.AsyncContent = AsyncContent;
exports.default = Object.assign(CardContent, { Async: AsyncContent });
